import { api } from '../api/api';

export interface ClientError {
  id: number;
  uuid: string;
  timestamp: string;
  severity: string;
  category: string;
  message: string;
  stackTrace?: string;
  url?: string;
  component?: string;
  browser?: string;
  browserName?: string;
  browserVersion?: string;
  os?: string;
  screenResolution?: string;
  username?: string;
  tenantName?: string;
  errorCount: number;
  firstOccurrence: string;
  lastOccurrence: string;
  resolved: boolean;
  resolvedBy?: string;
  resolvedOn?: string;
}

export async function fetchClientErrors(): Promise<ClientError[]> {
  const response = await api.get<ClientError[]>('/api/client-errors');
  return response.data;
}
